import React from "react";
import SEO from "../components/SEO";
import Hero from "../components/Hero";
import TrustStrip from "../components/TrustStrip";
import Services from "../components/Services";
import CalculatorWidget from "../components/CalculatorWidget";
import Subscription from "../components/Subscription";
import Features from "../components/Features";
import Gallery from "../components/Gallery";
import Reviews from "../components/Reviews";
import FAQ from "../components/FAQ";
import ServiceAreas from "../components/ServiceAreas";
import Contact from "../components/Contact";

export default function HomePage() {
  return (
    <>
      <SEO />
      <Hero />
      <TrustStrip />
      <Services />
      <CalculatorWidget />
      <Subscription />
      <Features />
      <Gallery />
      <Reviews />
      <FAQ />
      <ServiceAreas />
      <Contact />
    </>
  );
}
